
import React, { Component } from "react";
import PageTitle from "../Components/Theme/PageTitle";
import DashboardLayout from "../Components/Theme/DashboardLayout";
import SelectDayTypeResourceInfoCard from '../Components/DayType/SelectDayTypeResource/SelectDayTypeResourceInfoCard';
import { Col, Row, Modal, Select } from "antd";
import { InfoCard } from "../Components/Theme/Cards";
import { Link, Redirect } from 'react-router-dom';
import Spinner from '../Components/Theme/Spinner';
import { StrokeIcon } from "../Components/Theme/Icon";
import moment from 'moment';
import { WrappedDayTypeCalendarForm } from '../Components/DayType/DayTypeCalendarForm';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import * as dayTypeActions from '../redux/actions/dayTypeActions';
import * as resourceActions from '../redux/actions/resourceActions';
import generateCalendarEvents from '../Components/DayType/utils/generate-events'
import AuthLogic from '../AuthLogic/';


export class DayTypesPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            calendarViewModal: false,
            calendarStartDate: moment().startOf('year'),
            calendarFormSubmitted: false,
        }
    }

    showCalendarViewModal = () => {
        this.setState({
            calendarViewModal: true,
        });
    };

    handleCalendarViewModalCancel = (e) => {
        this.setState({
            calendarViewModal: false
        });
    };

    handleCalendarStartDateChange = date => {
        this.setState({
            calendarStartDate: date || moment()
        });
    };

    handleCalendarFormSubmit = async () => {
        let selectedResourceId = this.props.selectedDayTypeResource.id || this.props.user.login.resourceId;
        this.handleCalendarViewModalCancel()
        this.setState({
            calendarFormSubmitted: true,
        });
    };

    updateResource = () => {
        this.setState({
            resource: this.props.selectedDayTypeResource,
            loaded: false
        }, () => {
            console.log(`resourceName: ${this.state.resource.name}, resourceId: ${this.state.resource.id}`);
        });
    }

    render() {
        if (!this.props.user) {
            <Redirect
                to={{
                    pathname: '/'
                }}
            />
        }
        if (this.props.user.securityLevels) {
            return (
                <DashboardLayout>

                    <PageTitle title={'Days Off and Availability'}
                        subTitle={ // show logged in user or selectedDayTypeResource
                            this.props.selectedDayTypeResource.name
                                ? this.props.selectedDayTypeResource.name
                                : this.props.user.userDemographics.name
                        } />

                    <Row gutter={32}>
                        {AuthLogic.addDayTypeRequest(this.props.user)&&<Col lg={8} md={24} >
                            <Link to="/day-types-requests-view">
                                <InfoCard icon={<StrokeIcon icon={'plane'} />}
                                    value={'My Day Off Requests'} /></Link>
                        </Col>}

                        {AuthLogic.viewCalendar(this.props.user) &&
                            <Col lg={8} md={24}>
                                <Link to="#" onClick={this.showCalendarViewModal}>
                                    <InfoCard icon={<StrokeIcon icon={'date'} />}
                                        value={'My Calendar View'} /></Link>
                            </Col>
                        }
                        {
                            AuthLogic.changeAbsencesResource(this.props.user) &&
                            <SelectDayTypeResourceInfoCard updatePageCallback={this.updateResource} />
                        }

                        <Modal
                            visible={this.state.calendarViewModal}
                            title="Select Start Date for Calendar View"
                            zIndex={2000}
                            onCancel={this.handleCalendarViewModalCancel}
                            footer={[

                            ]}
                        >
                            <WrappedDayTypeCalendarForm
                                calendarStartDate={this.state.showCalendarStartDate}
                                handleStartDateChange={this.handleCalendarStartDateChange}
                                handleCalendarFormSubmit={this.handleCalendarFormSubmit}
                            />

                        </Modal>


                        {this.state.calendarFormSubmitted && (
                            <Redirect
                                to={{
                                    pathname: '/day-types-calendar-view',
                                    state: {
                                        startDate: this.state.calendarStartDate,
                                    }
                                }}
                            />
                        )}

                    </Row>

                </DashboardLayout>
            )
        } else
            return <Spinner />
    }
}

DayTypesPage.propTypes = {
    user: PropTypes.object.isRequired,
    dayTypeCalendar: PropTypes.object,
    dayTypeSecurity: PropTypes.object
};

function mapStateToProps(state) {
    return {
        user: state.user,
        selectedDayTypeResource: state.selectedDayTypeResource,
        dayTypeCalendar: state.dayTypeCalendar,
        dayTypeSecurity: state.dayTypeSecurity
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            fetchDayTypeCalendar: bindActionCreators(
                dayTypeActions.fetchDayTypeCalendar,
                dispatch
            ),
            updateSelectedDayTypeResource: bindActionCreators(
                resourceActions.updateSelectedDayTypeResource,
                dispatch
            ),
            fetchDayTypeSecurity: bindActionCreators(
                dayTypeActions.fetchDayTypeSecurity,
                dispatch
            )
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DayTypesPage);



// WEBPACK FOOTER //
// ./src/Pages/DayTypesPage.js